import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const Atras = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navegar hacia atrás
  };

  const styles = {
    button: {
      bgcolor: "rgba(255, 255, 255, 0.15)",
      color: "inherit",
      "&:hover": {
        bgcolor: "rgba(255, 255, 255, 0.3)",
      },
    },
  };

  return (
    <IconButton onClick={handleGoBack} sx={styles.button} aria-label="Volver">
      <ArrowBackIcon />
    </IconButton>
  );
};

export default Atras;
